import React, { useEffect, useState } from "react";
import backicon from './../../../../../../Assets/icons/backIcon.svg'
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API"; // Adjust the API instance import as per your setup
import Swal from 'sweetalert2';
import Loader from "../../../../../customComponents/CustomLoader";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";



const EditWheels = () => {
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const Token = localStorage.getItem("authToken");
  const [ editUnit, setEditUnit ] = useState([])
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const [ userTypedd, setUserTypedd ] = useState([])

  const userType = localStorage.getItem("UserType")
  const businessPartnerId = localStorage.getItem("business_partner_id")

  useEffect(() => {
    userTypedropdown()
  },[])

  const userTypedropdown = async () => {
    try{
      const response = await axiosInstance.get("/bp-onboard/bplist",{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
      })

      const data = response.data.data.data
      const userTypeOptions = data.map(user => ({
        value: user.onboard_id,
        label:user.bp_name,
      }))
      setUserTypedd(userTypeOptions)
    }catch(error) {
      console.log(error)
    }
  }


  const location = useLocation();

  const { data } = location.state || {};
  console.log("seatcapacitydata",data);
  


const fetchUnitEdit = async () => {
  try{
    const response = await axiosInstance.get(`/wheel/edit/${data.wheel_id}`,{
      headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
      },
  })
  const formatData = response.data.data
  const formatedData = {
            noofwheels: formatData.no_of_wheel,
            description: formatData.wheel_desc,
            status: formatData.status === 1 ? "Active" : "Inactive",
            business_partner_id:formatData.business_partner_id
  }
  setFormData(formatedData)
  setEditUnit(formatData)
  console.log(formData, "HSNCODE DATA")

}catch(error){
    console.log(error)
  }

}

useEffect(() => {
  fetchUnitEdit()
},[])


const handleFormSubmit = async (formData) => {
  const errors = {};
  let isValid = true;

  // Validate required fields
  UnitInputs.forEach((field) => {
    if (field.validation && field.validation.required) {
      if (!formData[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false; // Ensure isValid is set to false on error
      }
    }
  });

  // If validation fails, set errors and return
  if (!isValid) {
    setValidationErrors(errors);
    return;
  }

 
  const confirmation = await Swal.fire({
    title: "Are you sure?",
    text: "Do you want to update this record?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
  });
  if (confirmation.isConfirmed) {
    try {
      setLoading(true);
      const payload = {
        no_of_wheel: formData.noofwheels,
        wheel_desc: formData.description,
                status: formData.status === "Active" ? 1 : 0,
              };
              if (userType === "superadmin") {
                payload.business_partner_id = formData.business_partner_id;
              } else {
                payload.business_partner_id = businessPartnerId;
              }
      await axiosInstance.patch(`/wheel/update/${data.wheel_id}`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
      });
      await Swal.fire({
        title: "Success",
        text: "Seating Capacity updated successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });
      navigate(ROUTES_NAVIGATION.WHEELLIST);
    } catch (error) {
      console.error("Error updating unit:", error);
      const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
      await Swal.fire({
        title: "Something went wrong",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  } else {
    setLoading(false); // Ensure loading is reset if canceled
  }
};


const backNavigate = () => {
  navigate(ROUTES_NAVIGATION.WHEELLIST);
};

const UnitInputs = [
  ...(userType === "superadmin"
    ? [
        {
          name: "business_partner_id",
          label: "Business Partner",
          type: "dropdown",
          required: true,
          options: userTypedd,
          gridClass: "col-lg-4",
          validation: { required: true}
        },
      ]
    : []),
  {
    name: "noofwheels",
    label: "No Of Wheels",
    placeholder:"Enter No. of Wheels",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
    validation: { required: true,
      pattern: /^[0-9]*$/,
      message: "Only  digits are allowed*",
      MaxLength:2
     },
  },
  {
    name: "description",
    label: "Description",
    placeholder:"Enter  Description",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
    validation: { required: true },
  },
  {
    name: "status",
    label: "Status",
    type: "dropdown",
    required: true,
    options: [
      { id: 1, label: "Active", value: "Active" },
      { id: 0, label: "Inactive", value: "Inactive" },
    ],
    gridClass: "col-lg-4",
    validation: { required: true },
  },
];
  return (
    <>
     <div>
    {loading ? ( 
      <Loader />
    ) : (
      <><div className="backbutton mt-2 mb-2" onClick={backNavigate}>
              <img onClick={backNavigate} src={backicon} alt="back" />
              <span className="backbtntitle">Edit Wheel</span>
            </div><div className="form-container">
                <span className="cust-det-title mt-2 mb-2">
                  Please Enter Wheel Details
                </span>
                <DynamicForm
                  formConfig={UnitInputs}
                  formData={formData}
                  setFormData={setFormData}
                  onSubmit={handleFormSubmit}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors} />
              </div><div className="btncontainer mt-3">
                <button
                  onClick={() => handleFormSubmit(formData)}
                  className="submit-btn"
                >
                  Submit
                </button>
              </div></>
    )}
    </div>
    </>
  );
};

export default EditWheels;
